import { useCallback } from 'react'
import { useGlobalEvent } from '@highlight/ipc/react'
import { GlobalEvents } from '@highlight/ipc'
import { useUpdateLatestFact } from '../../../../store'

/**
 * WebSocket memory facts surface in the message actions row, which lives many
 * levels below. The listener sits here, mounted from `MessageListRoot`, because
 * the list is the one component guaranteed to be mounted for the lifetime of a
 * visible conversation.
 */
export function useRealtimeFactListener() {
  const updateLatestFact = useUpdateLatestFact()
  useGlobalEvent(
    'websocket:realtime_text_update',
    useCallback(
      (data: { text: string }) => {
        if (!data.text) return

        updateLatestFact(data.text)
        GlobalEvents.emit('memories:newMemoryDetected')
      },
      [updateLatestFact],
    ),
  )
}
